// 用工服务
export default [
	{
		path: '/employment',
		name: 'Employment',
		redirect: '/employment/index',
		component: () => import('@/views/employment/index'),
		meta: { title: '用工服务' },
		children: [
			{
				path: 'index',
				name: 'EmploymentIndex',
				component: () => import('@/views/employment/home'),
				meta: { title: '首页', whiteListed: true }
			},
			{
				path: 'recruitment-center',
				name: 'RecruitmentCenter',
				component: () => import('@/views/employment/recruitment-center'),
				meta: { title: '求职招聘专区' }
			},
			{
				path: 'hire',
				name: 'Hire',
				component: () => import('@/views/employment/hire'),
				meta: { title: '我要招聘' }
			},
			{
				path: 'job',
				name: 'Job',
				component: () => import('@/views/employment/job'),
				meta: { title: '我要求职' }
			},
			{
				path: 'recommend',
				name: 'Recommend',
				component: () => import('@/views/employment/recommend'),
				meta: { title: '简历详情' }
			},
			{
				path: 'job-detail',
				name: 'JobDetail',
				component: () => import('@/views/employment/jobDetail'),
				meta: { title: '岗位详情' }
			},
			{
				path: 'company-detail',
				name: 'CompanyDetail',
				component: () => import('@/views/employment/companyDetail'),
				meta: { title: '企业详情' }
			}
		]
	}
]
